const featSelectReducer = (state= null, action: any) => {
    switch(action.type){
        case "featureSelectionChange":
            return action.payload.featureId
        default:
            return state
    }
}

export default featSelectReducer;